import script from "./clinic-services.vue?vue&type=script&setup=true&lang=js"
export * from "./clinic-services.vue?vue&type=script&setup=true&lang=js"

import "./clinic-services.vue?vue&type=style&index=0&id=4d000bac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d000bac"]])

export default __exports__